namespace RedBullMOBILE360.SpecialEvent {
    export class SpecialEventColumns {
        static columnsKey = 'SpecialEvent.SpecialEvent';
    }
}